import { DailyAudio, DailyVideo, useMediaTrack } from "@daily-co/daily-react";
import type { ReactNode } from "react";

interface MediaViewProps {
  participantId: string;
  isSelf?: boolean;
  // Shown instead of the video when it isn't playable
  placeholder?: ReactNode;
}

export const MediaView = ({
  participantId,
  isSelf = false,
  placeholder = <div className="h-full w-full bg-black" />,
}: MediaViewProps) => {
  const videoTrack = useMediaTrack(participantId, "video");

  return (
    <>
      {videoTrack?.state === "playable" ? (
        <DailyVideo
          sessionId={participantId}
          type="video"
          fit="contain"
          className="w-full h-full object-contain"
          automirror={isSelf}
          muted={isSelf}
        />
      ) : (
        placeholder
      )}

      <DailyAudio />
    </>
  );
};
